export default __webpack_public_path__ + "static/media/TwitterLogo.95e6032b.svg";